// Module
var code = "<a href=\"javascript:;\" class=\"text-sm sps-btn sps-btn-outline btn-color-history history-button\"> <i class=\"fa fa-history\"></i><span data-bind=\"text: GetControlTypeTranslatedName()\"></span> </a>";
// Exports
export default code;